import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigation } from '../context/NavigationContext';
import { Screen } from '../types';
import { Button } from '../components/ui/Button';
const SLIDES = [{
  id: 1,
  icon: '🛍️',
  title: 'Shop the World',
  description: 'Millions of products at your fingertips. Find exactly what you need.'
}, {
  id: 2,
  icon: '🚚',
  title: 'Fast Delivery',
  description: 'Get your orders delivered quickly and safely to your doorstep.'
}, {
  id: 3,
  icon: '🔒',
  title: 'Secure Payments',
  description: 'Your transactions are always safe with our encrypted payment systems.'
}];
export function OnboardingScreen() {
  const [current, setCurrent] = useState(0);
  const {
    resetTo
  } = useNavigation();
  const handleNext = () => {
    if (current === SLIDES.length - 1) {
      resetTo(Screen.WELCOME);
    } else {
      setCurrent(c => c + 1);
    }
  };
  return <div className="flex flex-col min-h-screen bg-white p-6" data-id="element-839">
      <div className="flex justify-end pt-4" data-id="element-840">
        <button onClick={() => resetTo(Screen.WELCOME)} className="text-sm font-medium text-gray-500 hover:text-gray-900" data-id="element-841">
          Skip
        </button>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center relative" data-id="element-842">
        <AnimatePresence mode="wait" data-id="element-843">
          <motion.div key={current} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -20
        }} transition={{
          duration: 0.3
        }} className="flex flex-col items-center text-center w-full" data-id="element-844">
            <div className="text-9xl mb-12 drop-shadow-xl" data-id="element-845">
              {SLIDES[current].icon}
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-846">
              {SLIDES[current].title}
            </h2>
            <p className="text-gray-500 px-4 leading-relaxed" data-id="element-847">
              {SLIDES[current].description}
            </p>
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="pb-12 pt-6 flex flex-col items-center gap-8" data-id="element-848">
        <div className="flex gap-2" data-id="element-849">
          {SLIDES.map((_, idx) => <div key={idx} className={`h-2 rounded-full transition-all duration-300 ${current === idx ? 'w-8 bg-primary' : 'w-2 bg-gray-200'}`} data-id="element-850" />)}
        </div>

        <Button fullWidth size="lg" onClick={handleNext} data-id="element-851">
          {current === SLIDES.length - 1 ? 'Get Started' : 'Next'}
        </Button>
      </div>
    </div>;
}